import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { track } from '@/lib/analytics';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0 });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], subtotal: 0 }); return; }
    setLoading(true);
    try {
      const { data } = await api.get('/cart');
      setCart(data);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (payload) => {
    await api.post('/cart/add', payload);
    track('add_to_cart', { product_id: payload?.product_id, variant: payload?.variant, quantity: payload?.quantity });
    await refresh();
  };
  const updateQty = async (itemId, quantity) => {
    await api.patch(`/cart/item/${itemId}`, { quantity });
    await refresh();
  };
  const remove = async (itemId) => {
    await api.delete(`/cart/item/${itemId}`);
    track('remove_from_cart', { item_id: itemId });
    await refresh();
  };
  const clear = async () => {
    await api.delete('/cart');
    await refresh();
  };

  return (
    <CartContext.Provider value={{ cart, loading, refresh, add, updateQty, remove, clear }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
